import { FileWithPath } from '@mantine/dropzone';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { NotificationService } from 'services/notification-service';
import { SmartAssistantService } from 'services/smart-assistant-service';
import { SMART_ASSISTANT_QUERY_KEY } from 'shared/constants/query-keys';
import { SmartAssistant } from 'shared/interfaces/SmartAssistant';

export function useSmartAssistantAvatarUrlHandling(smartAssistant: SmartAssistant) {
  const { _id: smartAssistantId } = smartAssistant;

  const queryClient = useQueryClient();

  const updateAvatarMutation = useMutation({
    mutationFn: SmartAssistantService.updateSmartAssistantAvatar,
    onSuccess: () => {
      queryClient.invalidateQueries([SMART_ASSISTANT_QUERY_KEY, { smartAssistantId }]);
      NotificationService.showResult(true, 'FEED_BACK.SMART_ASSISTANT.SUCCESS.AVATAR_UPDATED');
    },
    onError: () => {
      NotificationService.showResult(false, 'FEED_BACK.SMART_ASSISTANT.FAILURE.AVATAR_UPDATED');
    }
  });

  const removeAvatarMutation = useMutation({
    mutationFn: SmartAssistantService.removeSmartAssistantAvatar,
    onSuccess: () => {
      queryClient.invalidateQueries([SMART_ASSISTANT_QUERY_KEY, { smartAssistantId }]);
      NotificationService.showResult(true, 'FEED_BACK.SMART_ASSISTANT.SUCCESS.AVATAR_UPDATED');
    },
    onError: () => {
      NotificationService.showResult(false, 'FEED_BACK.SMART_ASSISTANT.FAILURE.AVATAR_UPDATED');
    }
  });

  const handleImageDrop = (file: FileWithPath) => {
    updateAvatarMutation.mutate({
      id: smartAssistantId,
      avatarFile: file
    });
  };

  const backToDefaultAvatar = () => {
    removeAvatarMutation.mutate(smartAssistantId);
  };

  const isUpdatingAvatar = updateAvatarMutation.isLoading || removeAvatarMutation.isLoading;

  return {
    backToDefaultAvatar,
    handleImageDrop,
    isUpdatingAvatar
  };
}
